"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var useForm = function (initialValues, submitCallback) {
    var _a = react_1.useState(initialValues), inputs = _a[0], setInputs = _a[1];
    var submitHandler = function (event) {
        if (event)
            event.preventDefault();
        submitCallback();
    };
    var setFormMessage = function (msg) {
        setInputs(function (prevInputs) { return (tslib_1.__assign(tslib_1.__assign({}, prevInputs), { formMessage: msg })); });
    };
    var setValue = function (inputIdentifier, fieldName, fieldValue) {
        var updatedForm = tslib_1.__assign({}, inputs.form);
        var updatedFormElement = tslib_1.__assign({}, updatedForm[inputIdentifier]);
        updatedFormElement[fieldName] = fieldValue;
        updatedForm[inputIdentifier] = updatedFormElement;
        var formIsValid = true;
        for (var inputIdentifier_1 in updatedForm) {
            formIsValid = updatedForm[inputIdentifier_1].isValid && formIsValid;
        }
        setInputs({
            form: updatedForm,
            formIsValid: formIsValid,
            formMessage: "",
        });
    };
    var checkValidity = function (value, rules) {
        var isValid = true;
        if (!rules) {
            return true;
        }
        if (rules.required) {
            isValid = value.trim() !== "" && isValid;
        }
        // TODO: refactor this to appropriate rules
        // if (rules.minLength) {
        //     isValid = value.length >= rules.minLength && isValid;
        // }
        // if (rules.isNumeric) {
        //     const pattern = /^\d+$/;
        //     isValid = pattern.test(value) && isValid;
        // }
        return isValid;
    };
    var inputChangedHandler = function (event, inputIdentifier, isForced) {
        if (isForced === void 0) { isForced = false; }
        var updatedForm = tslib_1.__assign({}, inputs.form);
        var updatedFormElement = tslib_1.__assign({}, updatedForm[inputIdentifier]);
        if (!isForced) {
            updatedFormElement.value = event.target.checked
                ? event.target.checked
                : event.target.value;
        }
        updatedFormElement.isValid = checkValidity(updatedFormElement.value, updatedFormElement.validation);
        updatedFormElement.isTouched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        var formIsValid = true;
        for (var inputIdentifier_2 in updatedForm) {
            formIsValid = updatedForm[inputIdentifier_2].isValid && formIsValid;
        }
        setInputs({
            form: updatedForm,
            formIsValid: formIsValid,
            formMessage: "",
        });
    };
    return {
        inputs: inputs,
        inputChangedHandler: inputChangedHandler,
        submitHandler: submitHandler,
        setFormMessage: setFormMessage,
        setValue: setValue,
    };
};
exports.default = useForm;
